/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EligibilityReferenceResponseViewModel {
  id?: string;
  datasetId?: string;
  eligibilityReceiverResponseId?: string | null;
  eligibilitySubscriberResponseId?: string | null;
  eligibilityDependentResponseId?: string | null;
  referenceIdentificationQualifierCode?: string | null;
  referenceIdentificationCode?: string | null;
  referenceDescription?: string | null;
}
